export default function customTimingMessage(ErrorBag) {
  // get the original method.
  const first = ErrorBag.prototype.first;
  ErrorBag.prototype.first = function(...args) {
    // call it after binding it to the error bag instance.
    const msg = first.bind(this)(...args);
    // if there is a message returned, change the style.
    if (msg) {
      // TODO: You might need a better regex.
      // let FromVal = msg.match(/From/);
      // let toVal = msg.match(/To/);
      // if (FromVal || toVal)
      return msg.replace(/^The .+field/i, "This field");
    }
    return msg;
  };
}
